import { useTheme } from "@emotion/react";
import {
  Alert,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  MenuItem,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";

import { ArrowForwardIosOutlined, ClearOutlined } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import TicketModalContent from "../detailsTicketComponent";
import InternoModalConfirmacaoSaida from "../../modalSaindoDaPagina";
import apiCliente from "../../../services/apiCliente";
import EditTicketComponentCliente from "../editTicketComponentCliente";
import ModalAlertaDuplicidade from "../modalAlertaDuplicidade";
import { getErpPrincipal } from "../../../services/erpSistema";

export default function ModalNewTicketCliente(params) {
  const {
    open,
    handleClose = () => {},
    refrashTIckets = () => {},
    cliente = null,
    serviceId = null,
    // ERP do cliente logado (portal); sem ele, a variável do front.
    erp: erpProp,
    // Grupo econômico: empresas em que o usuário pode abrir ticket (lista de
    // /cliente/find/empresasNovoTicket). Com duas ou mais, ele escolhe; com
    // uma, ela é usada direto. Sem a prop (cliente comum), como antes.
    empresas = null,
  } = params;
  const [empresaId, setEmpresaId] = useState(null);
  const comEmpresas = Array.isArray(empresas);
  const escolheEmpresa = comEmpresas && empresas.length >= 2;
  const empresa = comEmpresas
    ? escolheEmpresa
      ? empresas.find((item) => item.id === empresaId) || null
      : empresas[0] || null
    : null;
  // Cliente do ticket: a empresa do grupo ou o do login.
  const clienteTicket = comEmpresas ? empresa : cliente;
  // Empresa (validada no backend) e ERP dela, nas chamadas do novo ticket.
  const ownerClienteId = empresa?.id || undefined;
  const erpIdTicket = empresa?.erpId || undefined;

  const [servicos, setServicos] = useState([]);
  const [loadingServicos, setLoadingServicos] = useState(false);
  const [loadingCreateTicket, setLoadingCreateTicket] = useState(false);
  const [dataTicket, setDataTicket] = useState({});
  const [tipoAtendimento, setTipoAtendimento] = useState([]);
  const [loadingParams, setLoadingParams] = useState(false);
  const [forms, setForms] = useState({});
  const [dataForms, setDataForms] = useState([]);
  const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
  const [isEditTicket, setIsEditTicket] = useState(false);
  const [isFinishTicket, setIsFinishTicket] = useState(false);
  const [isEditOs, setIsEditOs] = useState(false);
  const [isNewOs, setIsNewOs] = useState(false);
  const [isNewTicket, setIsNewTicket] = useState(false);
  const [itensPublic, setItensPublic] = useState({
    mensagens: [],
    anexos: [],
    rfo: [],
  });
  const [files, setFiles] = useState([]);
  const [value, setValue] = useState(0);
  const [ticketDetails, setTicketDetails] = useState(null);
  const [snackbar, setSnackbar] = useState(null);
  const [error, setError] = useState(false);
  const [duplicateTicketsAlert, setDuplicateTicketsAlert] = useState([]);
  const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
  const [isViewingDuplicateTicket, setIsViewingDuplicateTicket] =
    useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  const erp = erpProp || getErpPrincipal();
  const rawEnvValue =
    window?.config?.REACT_APP_PHONE_TICKET_ENABLE ??
    process.env.REACT_APP_PHONE_TICKET_ENABLE;

  const phoneTicketEnable =
    rawEnvValue === "false" || rawEnvValue === false ? false : true;
  const labelTabsErp = {
    descricao:
      erp === "HUBSOFT"
        ? "Descrição"
        : erp === "VOALLE"
          ? "Geral"
          : "Descrição",
    mensagens:
      erp === "HUBSOFT"
        ? "Mensagens"
        : erp === "VOALLE"
          ? "Histórico"
          : "Mensagens",
  };
  const colors = Object.keys(theme.palette.colors)?.filter(
    (color) => color !== "white" && color !== "black",
  );
  const handleCancelNavigation = () => {
    setConfirmacaoSaidaPagina(false);
  };

  useEffect(() => {
    if (
      dataTicket?.clienteServicoId &&
      dataTicket?.tipoAtendimentoId &&
      !isEditTicket
    ) {
      checkDuplicidade(
        dataTicket.clienteServicoId,
        dataTicket.tipoAtendimentoId,
      );
    } else {
      setDuplicateTicketsAlert([]);
      setOpenDuplicateDialog(false);
    }
  }, [dataTicket?.clienteServicoId, dataTicket?.tipoAtendimentoId]);

  const checkDuplicidade = async (clienteServicoId, tipoAtendimentoId) => {
    try {
      const response = await apiCliente.post("/cliente/find/ticketDuplicado", {
        clienteServicoId,
        tipoAtendimentoId,
        ownerClienteId,
      });
      if (response?.data?.duplicado && response?.data?.tickets?.length > 0) {
        setDuplicateTicketsAlert(response.data.tickets);
        setOpenDuplicateDialog(true);
      }
    } catch (error) {
      console.error("Erro ao verificar duplicidade de ticket:", error);
    }
  };

  const handleOpenExistingTicket = async (ticket) => {
    if (!ticket?.id_atendimento) return;
    setOpenDuplicateDialog(false);
    setIsViewingDuplicateTicket(true);
    try {
      const response = await apiCliente.post("/cliente/find/tickets/id", {
        ticketId: ticket.id_atendimento,
        erpId: erpIdTicket,
      });
      if (response?.data) {
        setTicketDetails(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar detalhes do ticket:", error);
    }
  };

  function adicionarCores(objetos) {
    return objetos?.reduce((acc, item, index) => {
      acc[item] = colors[index % colors?.length];
      return acc;
    }, {});
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    // Grupo com várias empresas: espera a escolha (as listas são do ERP dela).
    if (open && (!escolheEmpresa || empresa)) {
      getParamsNewTicket();
    }
  }, [open, ownerClienteId]);

  useEffect(() => {
    if (clienteTicket) {
      // Troca de empresa: recomeça (serviço e tipo são do ERP da anterior).
      setDataTicket((prev) => ({
        ...(comEmpresas ? {} : prev),
        nome: clienteTicket?.nome || null,
        cnpj: clienteTicket?.cnpj,
        clienteErpId: clienteTicket?.clienteErpId,
      }));
      if (comEmpresas) setServicos([]);
    }
  }, [comEmpresas ? ownerClienteId : cliente, open]);

  useEffect(() => {
    if (serviceId && dataTicket?.clienteErpId) {
      const filter = servicos?.find(
        (item) => item?.id_cliente_servico === serviceId,
      );

      if (filter) {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: filter?.id_cliente_servico,
        });
      } else {
        setDataTicket({
          ...dataTicket,
          clienteServicoId: null,
        });
      }
    }
  }, [servicos, dataTicket?.clienteErpId, serviceId]);

  useEffect(() => {
    // Busca ao abrir: abrir o modal limpa a lista do grupo (efeito acima).
    if (open && dataTicket?.cnpj) {
      getServicos();
    }
  }, [open, dataTicket?.cnpj, ownerClienteId]);

  useEffect(() => {
    if (dataTicket?.clienteServicoId) {
      getInfoClientNewTicket();
    }
  }, [dataTicket?.clienteServicoId]);

  const closeModal = () => {
    if (loadingCreateTicket) return;
    handleClose();
    setDataTicket({});
    setEmpresaId(null);

    setForms({});
    setIsEditTicket(false);
    setIsFinishTicket(false);
    setIsEditOs(false);
    setIsNewOs(false);
    setIsViewingDuplicateTicket(false);

    setError(false);
    setTicketDetails(null);
    setFiles([]);
    setConfirmacaoSaidaPagina(false);
    //Caso tenha ocorrido um novo ticket, atualizar os tickets ao fechar o modal
    if (isNewTicket) {
      refrashTIckets();
      setIsNewTicket(false);
    }
  };

  const handleCloseModalOrTicketView = () => {
    if (isViewingDuplicateTicket) {
      if (isEditTicket || isFinishTicket || isEditOs || isNewOs) {
        setConfirmacaoSaidaPagina(true);
      } else {
        setTicketDetails(null);
        setIsViewingDuplicateTicket(false);
        setOpenDuplicateDialog(true);
      }
      return;
    }
    if (
      isEditTicket ||
      isFinishTicket ||
      isEditOs ||
      isNewOs ||
      (open && !ticketDetails)
    ) {
      setConfirmacaoSaidaPagina(true);
    } else {
      closeModal();
    }
  };

  const handleConfirmExit = () => {
    if (isViewingDuplicateTicket) {
      setIsEditTicket(false);
      setIsFinishTicket(false);
      setIsEditOs(false);
      setIsNewOs(false);
      setTicketDetails(null);
      setIsViewingDuplicateTicket(false);
      setOpenDuplicateDialog(true);
      setConfirmacaoSaidaPagina(false);
    } else {
      closeModal();
    }
  };

  const createTicket = async () => {
    if (
      !dataTicket?.clienteErpId ||
      !dataTicket?.clienteServicoId ||
      !dataTicket?.telefone ||
      !dataTicket?.descricaoAbertura ||
      !dataTicket?.tipoAtendimentoId ||
      dataTicket?.descricaoAbertura?.length < 10
    ) {
      setSnackbar({
        severity: "warning",
        children: "Preencha todos os campos obrigatórios",
      });

      setError(true);
      return;
    }

    setError(false);
    setLoadingCreateTicket(true);

    const formData = new FormData();
    if (files?.length > 0) {
      const totalSize = files.reduce((total, file) => total + file?.size, 0);
      const maxSize = 20 * 1024 * 1024; // 20MB em bytes
      if (totalSize > maxSize) {
        setSnackbar({
          severity: "warning",
          children: `Tamanho total dos arquivos (${(
            totalSize /
            (1024 * 1024)
          )?.toFixed(2)}MB) excede o limite de 20MB.`,
        });
        setLoadingCreateTicket(false);
        return;
      }

      files.forEach((file) => {
        formData.append("files", file);
      });
    }
    formData.append("dataTicket", JSON.stringify(dataTicket));
    if (ownerClienteId) formData.append("ownerClienteId", ownerClienteId);

    if (Object.keys(forms)?.length > 0) {
      formData.append("forms", JSON.stringify(forms));
    }

    try {
      const response = await apiCliente.post(
        "/cliente/create/ticket",
        formData,
      );
      setTicketDetails(response?.data);
      setIsNewTicket(true); //Estado para monitorar se ocorreu criação de novo ticket
    } catch (error) {
      console.error("Erro ao criar ticket:", error);
      setSnackbar({
        children: "Error: Erro ao criar atendimento",
        severity: "error",
      });
    } finally {
      setLoadingCreateTicket(false);
    }
  };

  const getParamsNewTicket = async () => {
    setLoadingParams(true);
    try {
      const response = await apiCliente.post("/cliente/find/paramsNewTicket", {
        ownerClienteId,
      });

      setTipoAtendimento(response?.data?.tipoAtendimento || []);
      setDataForms(response?.data?.forms || []);
      setDataTicket((prev) => ({
        ...prev,
        idEtapaFluxoAtendimento:
          response?.data?.etapasFluxoAtendimento?.[0]
            ?.idEtapaFluxoAtendimento || null,
      }));
    } catch (error) {
      console.error("Erro ao buscar clientes:", error);
    } finally {
      setLoadingParams(false);
    }
  };
  const getServicos = async () => {
    try {
      setLoadingServicos(true);
      const response = await apiCliente.post("/cliente/find/allServiceClient", {
        cnpj: dataTicket?.cnpj,
      });
      // Grupo: só os serviços da empresa escolhida.
      setServicos(
        comEmpresas
          ? (response?.data || []).filter(
              (servico) => servico?.ownerClienteId === ownerClienteId,
            )
          : response?.data,
      );
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };
  const getInfoClientNewTicket = async () => {
    try {
      setLoadingServicos(true);
      const response = await apiCliente.post(
        "/cliente/find/infoClienteNewTicket",
        {
          clienteServiceId: dataTicket?.clienteServicoId,
          ownerClienteId,
        },
      );
      setDataTicket((prev) => ({
        ...prev,
        telefone: phoneTicketEnable
          ? response?.data?.contato?.telefone || ""
          : "",
        email: response?.data?.contato?.email || "",
        enderecoInstalacao: response?.data?.endereco_instalacao || "",
      }));
    } catch (error) {
      console.error("Erro ao buscar serviços:", error);
    } finally {
      setLoadingServicos(false);
    }
  };

  const handleCloseConfirmation = () => {
    setConfirmacaoSaidaPagina(true);
  };

  return (
    <>
      {ticketDetails ? (
        <TicketModalContent
          open={open}
          handleClose={handleCloseModalOrTicketView}
          erp={erp}
          erpId={erpIdTicket}
          ticketDetails={ticketDetails}
          status={ticketDetails?.status}
          labelTabsErp={labelTabsErp}
          value={value}
          handleChange={handleChange}
          isEdit={false}
          setTicketDetails={setTicketDetails}
          itensPublic={itensPublic}
          setItensPublic={setItensPublic}
          setSnackbar={setSnackbar}
          fluxoAtendimentoColor={adicionarCores(
            ticketDetails?.allEtapasFluxoAtendimentos,
          )}
          setIsEditTicket={setIsEditTicket}
          isEditTicket={isEditTicket}
          setIsFinishTicket={setIsFinishTicket}
          isFinishTicket={isFinishTicket}
          isEditOs={isEditOs}
          setIsEditOs={setIsEditOs}
          setIsNewOs={setIsNewOs}
          isNewOs={isNewOs}
          isCliente={true}
        />
      ) : (
        <Drawer
          anchor="right"
          open={open}
          onClose={handleCloseConfirmation}
          PaperProps={{
            sx: {
              width: "80%",
              maxWidth: "80%",
            },
          }}
        >
          <Box sx={styles.containerModal}>
            {loadingCreateTicket ? (
              <Box sx={styles.conatinerLoading}>
                <CircularProgress />
              </Box>
            ) : (
              <Box
                sx={{
                  height: "100vh",
                  overflow: "auto",
                  padding: "0 40px",
                }}
              >
                <Box sx={styles.BoxExitModal}>
                  <IconButton onClick={handleCloseConfirmation}>
                    <ArrowForwardIosOutlined sx={{ fontSize: "20px" }} />
                  </IconButton>
                </Box>
                <Box sx={{ padding: "20px 0", mt: 3 }}>
                  <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                    Criar novo ticket
                  </Typography>
                </Box>
                {escolheEmpresa && (
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Empresa"
                    value={empresaId || ""}
                    onChange={(event) => setEmpresaId(event.target.value)}
                    error={error && !empresa}
                    sx={{ mb: 2 }}
                  >
                    {empresas.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nome}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
                <EditTicketComponentCliente
                  loadingServicos={loadingServicos}
                  loadingCreateTicket={loadingCreateTicket}
                  loadingParams={loadingParams}
                  servicos={servicos}
                  setDataTicket={setDataTicket}
                  dataTicket={dataTicket}
                  error={error}
                  tipoAtendimento={tipoAtendimento}
                  isAddAnexo={cliente?.configPermissao?.sendAnexo}
                  files={files}
                  setFiles={setFiles}
                  setForms={setForms}
                  forms={forms}
                  dataForms={dataForms}
                />
                <Box sx={styles.containerButton}>
                  <Button
                    disabled={loadingCreateTicket}
                    onClick={handleCloseConfirmation}
                    size="small"
                  >
                    Cancelar
                  </Button>
                  <LoadingButton
                    onClick={() => createTicket()}
                    size="small"
                    loading={loadingCreateTicket}
                    variant="contained"
                  >
                    Salvar
                  </LoadingButton>
                </Box>
              </Box>
            )}

            {!!snackbar && (
              <Snackbar
                open
                onClose={() => setSnackbar(null)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert {...snackbar} onClose={() => setSnackbar(null)} />
              </Snackbar>
            )}
          </Box>
        </Drawer>
      )}
      <ModalAlertaDuplicidade
        open={openDuplicateDialog}
        onClose={() => {
          setOpenDuplicateDialog(false);
          setDataTicket((prev) => ({ ...prev, tipoAtendimentoId: "" }));
        }}
        onOpenTicket={(ticket) =>
          handleOpenExistingTicket(ticket || duplicateTicketsAlert[0])
        }
        onProceed={() => setOpenDuplicateDialog(false)}
        tickets={duplicateTicketsAlert}
      />

      <InternoModalConfirmacaoSaida
        openConfirmacao={confirmacaoSaidaPagina}
        confirmLoad={false}
        setOpenConfirmacao={setConfirmacaoSaidaPagina}
        execute={handleConfirmExit}
        cancel={handleCancelNavigation}
        severity={"warning"}
        title={"Atenção"}
        contentText={
          "As alterações não salvas serão perdidas, deseja continuar?"
        }
        headerText={"Você está prestes a sair do modo de edição."}
        confirmText={"Continuar"}
      />
    </>
  );
}
